import {
	FeedTypes,
	mySociosFeedKeys,
	newsFeedKeys,
	partnerFeedKeys,
	type PostActivityType,
	userFeedKeys
} from '@capsicum/socios-core';

export enum FeedTabsEnum {
	MYSOCIOS = 'mySocios',
	SOCIAL = 'social'
}

export const enum SocialStorage {
	FavouriteFeedCompletedData = 'FavouriteFeedCompletedData'
}

export const FEED_TYPES_QUERY_MAP = {
	[FeedTypes.FAVOURITE_TEAM]: mySociosFeedKeys.favouriteTeam,
	[FeedTypes.FOLLOWED_TEAMS]: mySociosFeedKeys.followedTeams,
	[FeedTypes.PARTNER_FEED]: partnerFeedKeys.all,
	[FeedTypes.SOCIAL_FEED]: newsFeedKeys.posts,
	[FeedTypes.SUGGESTED_FEED]: mySociosFeedKeys.suggestedTeams,
	[FeedTypes.USER_FEED]: userFeedKeys.all
};

export type InfiniteQueryPostActivityType = {
	pageParams: Array<number>;
	pages: Array<{
		data: Array<PostActivityType>;
	}>;
};
